const LEADING_H1 = /^(?:\uFEFF)?(?:[ \t]*\r?\n)*[ \t]*#[ \t]+[^\r\n]+(?:\r?\n|$)/

export function stripLeadingMarkdownH1(content: string): string {
  return content.replace(LEADING_H1, '').replace(/^(?:[ \t]*\r?\n)+/, '')
}
